class Select2fn {
    static formatState(icon) {
        if (!icon.id) {
            return icon.text; // Jika tidak ada ID, hanya teks yang dikembalikan
        }

        const dataset = icon.element.dataset;

        switch (true) {
            case !!dataset.sym:
                return document.createRange().createContextualFragment(
                    `<i class="sym sym-${dataset.sym}"></i> ${icon.text}`
                );
            case !!dataset.img:
                return document.createRange().createContextualFragment(
                    `<img src="${dataset.img}"  alt="icon ${icon.text}"> ${icon.text}`
                );
            default:
                return icon.text; // Jika tidak ada dataset yang cocok, kembalikan teks saja
        }
    }
}


export default Select2fn;
